import {
  PIPE_SIDE_TOP,
  PIPE_SIDE_SIDE,
  PIPE_SIDE_LEFT,
  PIPE_SIDE_RIGHT,
  PIPE_ACCESSORY_RISER,
  PIPE_ACCESSORY_CLEANOUT,
  PIPE_ACCESSORY_INSERTA_TEE,
  PIPE_ACCESSORY_CLEANOUT_LEFT,
  PIPE_ACCESSORY_CLEANOUT_RIGHT,
  PIPE_ACCESSORY_STUB_CONCENTRIC,
  PIPE_ACCESSORY_STUB_CROWN_MATCHING,
  PIPE_ACCESSORY_STUB_INVERT_MATCHING,
} from './types';

export const mutualExclusiveMaps = [
  {
    [PIPE_ACCESSORY_CLEANOUT]: true,
    [PIPE_ACCESSORY_STUB_CROWN_MATCHING]: true
  },
  {
    [PIPE_ACCESSORY_CLEANOUT_LEFT]: true,
    [PIPE_ACCESSORY_STUB_CROWN_MATCHING]: true
  },
  {
    [PIPE_ACCESSORY_CLEANOUT_RIGHT]: true,
    [PIPE_ACCESSORY_STUB_CROWN_MATCHING]: true
  }
]

export const exceptionMap = [
  {
    /* available option */
    [PIPE_SIDE_TOP]: true,
    [PIPE_ACCESSORY_CLEANOUT_LEFT]: true,
    /* opposite attachment */
    [PIPE_SIDE_RIGHT]: true,
    [PIPE_ACCESSORY_STUB_CROWN_MATCHING]: true
  },
  {
    /* available option */
    [PIPE_SIDE_TOP]: true,
    [PIPE_ACCESSORY_CLEANOUT_RIGHT]: true,
    /* opposite attachment */
    [PIPE_SIDE_LEFT]: true,
    [PIPE_ACCESSORY_STUB_CROWN_MATCHING]: true
  }
]

export const sizingExceptionMap = [
  {
    /* available option */
    [PIPE_SIDE_LEFT]: true,
    [PIPE_ACCESSORY_CLEANOUT_LEFT]: true,
    [PIPE_ACCESSORY_STUB_CONCENTRIC]: true,
    [PIPE_ACCESSORY_INSERTA_TEE]: true,
    /* min size */
    minSize: 24
  },
  {
    /* available option */
    [PIPE_SIDE_RIGHT]: true,
    [PIPE_ACCESSORY_CLEANOUT_RIGHT]: true,
    [PIPE_ACCESSORY_STUB_CONCENTRIC]: true,
    [PIPE_ACCESSORY_INSERTA_TEE]: true,
    /* min size */
    minSize: 24
  },
  {
    /* available option */
    [PIPE_SIDE_SIDE]: true,
    [PIPE_ACCESSORY_CLEANOUT]: true,
    [PIPE_ACCESSORY_STUB_CONCENTRIC]: true,
    [PIPE_ACCESSORY_INSERTA_TEE]: true,
    /* min size */
    minSize: 24
  }
]


export const accessorySizesMap = {
    [PIPE_ACCESSORY_RISER]: [6,8,10,12,15,18,24],
    [PIPE_ACCESSORY_STUB_INVERT_MATCHING]: [6,8,10,12,15,18,24,30],
    [PIPE_ACCESSORY_STUB_CONCENTRIC]: [6,8,10,12,15,18,24,30],
    [PIPE_ACCESSORY_STUB_CROWN_MATCHING]: [6,8,10,12,15,18,24,30],
    [PIPE_ACCESSORY_INSERTA_TEE]: [4,6,8,10,12,15,18,24,30],
    [PIPE_ACCESSORY_CLEANOUT_LEFT]: [4, 6, 8],
    [PIPE_ACCESSORY_CLEANOUT]: [4, 6, 8],
    [PIPE_ACCESSORY_CLEANOUT_RIGHT]: [4, 6, 8]
};

export const accessoryMaxSizesMap = {
  [PIPE_ACCESSORY_RISER]:                 {12:10, 15:12,  18:15,  24: 18, 30: 24, 36:24,  42: 24, 48:24,  60: 24},
  [PIPE_ACCESSORY_STUB_INVERT_MATCHING]:  {12:12, 15:15,  18:18,  24: 18, 30: 18, 36:18,  42: 24, 48:24,  60: 30},
  [PIPE_ACCESSORY_STUB_CONCENTRIC]:       {12:12, 15:15,  18:18,  24: 18, 30: 18, 36:18,  42: 24, 48:24,  60: 30},
  [PIPE_ACCESSORY_STUB_CROWN_MATCHING]:   {12:12, 15:15,  18:18,  24: 18, 30: 18, 36:18,  42: 24, 48:24,  60: 30},
  [PIPE_ACCESSORY_INSERTA_TEE]:           {12:6,  15:8,   18:8,   24: 12, 30: 15, 36:18,  42: 18, 48:24,  60: 24},
  [PIPE_ACCESSORY_CLEANOUT_LEFT]:         {12:6,  15:8,   18:8,   24: 8,  30: 8,  36:8,   42: 8,  48:8,   60: 8},
  [PIPE_ACCESSORY_CLEANOUT]:              {12:6,  15:8,   18:8,   24: 8,  30: 8,  36:8,   42: 8,  48:8,   60: 8},
  [PIPE_ACCESSORY_CLEANOUT_RIGHT]:        {12:6,  15:8,   18:8,   24: 8,  30: 8,  36:8,   42: 8,  48:8,   60: 8}
};

/* insertaTee/Stub (rows) vs. raiser(columns) memo 60 */
export const accessoryRiserSizeMatrix = {
  12: {
    4: [4,6,8,10],
    6: [4,6,8,10],
    8: [4,6,8],
    10:[4,6],
    12: []
  },
  15: {
    4: [4,6,8,10,12],
    6: [4,6,8,10,12],
    8: [4,6,8,10,12],
    10: [4,6,8,10],
    12: [],
    15: []
  },
  18: {
    4: [4,6,8,10,12,15],
    6: [4,6,8,10,12,15],
    8: [4,6,8,10,12,15],
    10: [4,6,8,10,12],
    12: [4,6,8],
    15: [4,6,8],
    18: []
  },
  24: {
    4: [4,6,8,10,12,15,18],
    6: [4,6,8,10,12,15,18],
    8: [4,6,8,10,12,15,18],
    10: [4,6,8,10,12,15,18],
    12: [4,6,8,10,12,15],
    15: [4,6,8,10,12],
    18: [4,6,8,10],
    24: []
  },
  30: {
    4: [4,6,8,10,12,15,18,24],
    6: [4,6,8,10,12,15,18,24],
    8: [4,6,8,10,12,15,18,24],
    10: [4,6,8,10,12,15,18,24],
    12: [4,6,8,10,12,15,18,24],
    15: [4,6,8,10,12,15,18],
    18: [4,6,8,10],
    24: [],
    30: []
  },
  36: {
    4: [4,6,8,10,12,15,18,24],
    6: [4,6,8,10,12,15,18,24],
    8: [4,6,8,10,12,15,18,24],
    10: [4,6,8,10,12,15,18,24],
    12: [4,6,8,10,12,15,18,24],
    15: [4,6,8,10,12,15,18],
    18: [4,6,8,10],
    24: [],
    30: []
  },
  42: {
    4: [4,6,8,10,12,15,18,24],
    6: [4,6,8,10,12,15,18,24],
    8: [4,6,8,10,12,15,18,24],
    10: [4,6,8,10,12,15,18,24],
    12: [4,6,8,10,12,15,18,24],
    15: [4,6,8,10,12,15,18,24],
    18: [4,6,8,10,12,15],
    24: [4,6,8,10],
    30: []
  },
  48: {
    4: [4,6,8,10,12,15,18,24],
    6: [4,6,8,10,12,15,18,24],
    8: [4,6,8,10,12,15,18,24],
    10: [4,6,8,10,12,15,18,24],
    12: [4,6,8,10,12,15,18,24],
    15: [4,6,8,10,12,15,18,24],
    18: [4,6,8,10,12,15,18],
    24: [4,6,8,10],
    30: []
  },
  60: {
    4: [4,6,8,10,12,15,18,24],
    6: [4,6,8,10,12,15,18,24],
    8: [4,6,8,10,12,15,18,24],
    10: [4,6,8,10,12,15,18,24],
    12: [4,6,8,10,12,15,18,24],
    15: [4,6,8,10,12,15,18,24],
    18: [4,6,8,10,12,15,18,24],
    24: [4,6,8,10,12,15,18,24],
    30: [4,6,8,10]
  }
};

/* insertaTee/Stub (rows) vs. Cleanout(columns) memo 60 */
export const accessoryCleanOutSizeMatrix = {
  12: {
    4: [],
    6: [],
    8: [],
    10:[],
    12:[]
  },
  15: {
    4: [],
    6: [],
    8: [],
    10: [],
    12: [],
    15: []
  },
  18: {
    4: [],
    6: [],
    8: [],
    10: [],
    12: [],
    15: [],
    18: []
  },
  24: {
    4: [4,6,8],
    6: [4,6,8],
    8: [4,6,8],
    10: [4,6,8],
    12: [],
    15: [],
    18: [],
    24: []
  },
  30: {
    4: [4,6,8],
    6: [4,6,8],
    8: [4,6,8],
    10: [4,6,8],
    12: [4,6,8],
    15: [],
    18: [],
    24: [],
    30: []
  },
  36: {
    4: [4,6,8],
    6: [4,6,8],
    8: [4,6,8],
    10: [4,6,8],
    12: [4,6,8],
    15: [],
    18: [],
    24: [],
    30: []
  },
  42: {
    4: [4,6,8],
    6: [4,6,8],
    8: [4,6,8],
    10: [4,6,8],
    12: [4,6,8],
    15: [4,6,8],
    18: [],
    24: [],
    30: []
  },
  48: {
    4: [4,6,8],
    6: [4,6,8],
    8: [4,6,8],
    10: [4,6,8],
    12: [4,6,8],
    15: [4,6,8],
    18: [],
    24: [],
    30: []
  },
  60: {
    4: [4,6,8],
    6: [4,6,8],
    8: [4,6,8],
    10: [4,6,8],
    12: [4,6,8],
    15: [4,6,8],
    18: [4,6,8],
    24: [4,6,8],
    30: []
  }
};



// WEBPACK FOOTER //
// ./src/lib/accessories.js